/**
 * Event Sticky Mobile CTA
 */

export function initStickyCta(): void {
  const stickyCta = document.querySelector<HTMLElement>('[data-sticky-cta]');
  const header = document.getElementById('registration-form');

  if (!stickyCta || !header) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        stickyCta.hidden = entry.isIntersecting;
      });
    },
    { threshold: 0.1 },
  );

  observer.observe(header);
}
